import React, { useCallback, useState } from 'react'
import styled from 'styled-components'


// hooks
import useOpenBlindBox from '../../hooks/nft/useOpenBlindBox'
import { stopPropagation } from '../../utils/func'

// components
import Loader from '../Loader'
import { AutoRow } from '../Row'
import Row from '../Row'
import { ButtonConfirmed } from '../Button'
import ArtworkBtn from '../nftInfo/button/ArtworkBtn'
import TransferBtn from '../nftInfo/button/TransferBtn'
import StakeBtn from '../nftInfo/button/StakeBtn'

const HotRow = styled.div`
  width: 100%;
`
const Button = styled(ButtonConfirmed)`
  padding: 0;
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  align-self: flex-start; 
  margin-bottom: 10px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`
const BtnRow = styled(Row)`
  margin-top: 10px;
  justify-content: space-between;
  button {
    width: 47%;
  }
`

const OtherBtns = styled(Row)<{isStaked?: boolean}>`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${({isStaked}) => (isStaked ? '-10px' : '10px')};
  button {
    width: 47%;
    flex: 1 1 auto;
    margin-right: 16px;
  }
  button:last-child {
    margin-right: 0px;
  }
`

export default function InfoButton ({
  artwork, 
  type, 
  nftType,
  ids,
  myAksIds,
  isMyArtwork, 
  tokenName, 
  stakesIds,
  stakesIds2,
  stakesIds_v2,
  isBlindbox, 
  isCanTransfer, 
  isCanStake,
  allowanceStake
}: {
  artwork: any, 
  type: string, 
  nftType: string,
  isMyArtwork?: boolean, 
  tokenName?: string,
  isBlindbox?: boolean, 
  isCanTransfer?: boolean,
  isCanStake?: boolean,
  allowanceStake?: boolean, 
  stakesIds?: any,
  stakesIds2?: any,
  stakesIds_v2?: any,
  ids?: any,
  myAksIds?: any
}) {

  const symbol = tokenName || 'BAKE'

  // 开盲盒
  const { onOpenBlindBox } = useOpenBlindBox(artwork.tokenId, type)
  const [requestedOpen, setRequestedOpen] = useState(false)
  const handleOpen = useCallback(async (event) => {
      try {
          stopPropagation(event)
          setRequestedOpen(true)
          const txHash = await onOpenBlindBox()
          if (!txHash) {
              setRequestedOpen(false)
          } else {
              setTimeout(() => {
                  setRequestedOpen(false)
              }, 10000)
          }
      } catch (e) {
          console.log(e)
      }
  }, [onOpenBlindBox])

  return <>
    <HotRow>
      {stakesIds.includes(artwork.tokenId) || stakesIds2.includes(artwork.tokenId) || isBlindbox ? null : 
        (
          <ArtworkBtn
            artwork={artwork}
            status={1}
            isMyArtwork={isMyArtwork}
            ids={ids}
            myAksIds={myAksIds}
            marketType={nftType}
            symbol={symbol}
          />
        )
      }
      {
        !isMyArtwork ? null :
        <BtnRow>
          {
            isBlindbox ?
            <Button
              onClick={handleOpen}
              disabled={requestedOpen}
              fontSize={14}
              height={40}
              altDisabledStyle={requestedOpen} // show solid button while waiting
              style={{
                  padding: '0',
                  width: '100%'
              }}
            >
              {
                requestedOpen ? 
                  <AutoRow gap="6px" justify="center">
                      Opening <Loader stroke="white" />
                  </AutoRow>
                : 'Open'
              }
            </Button>
            : 
            <OtherBtns isStaked={stakesIds2.includes(artwork.tokenId) || stakesIds.includes(artwork.tokenId)}>
              {
                isCanTransfer && !stakesIds.includes(artwork.tokenId) && !stakesIds2.includes(artwork.tokenId) && isMyArtwork && !ids.includes(artwork.tokenId)
                ? <TransferBtn artwork={artwork} marketType={nftType} />
                : null
              }
              {
                isCanStake && !ids.includes(artwork.tokenId) &&
                <StakeBtn artwork={artwork} gameType={type} />
              }
            </OtherBtns>
          }
        </BtnRow>
      }
    </HotRow>
  </>
}
